module.exports = __webpack_public_path__ + "../resources/img/ic-re-help-default.c4889317.svg";